// src/features/rrhh/mensajeria/api/chatApi.js
import httpClient from "../../../../shared/api/httpClient";
import { qs } from "../../../../shared/api/qs";

function getLicenseIdOrThrow() {
  try {
    const v = localStorage.getItem("sabi_empresa_id");
    if (!v) throw new Error();
    const n = Number(v);
    if (!Number.isFinite(n) || n <= 0) throw new Error();
    return n;
  } catch {
    throw new Error("No se encontró sabi_empresa_id en localStorage (license requerida).");
  }
}

function getCurrentUserIdOrThrow() {
  try {
    const raw = localStorage.getItem("sabi_user");
    if (!raw) throw new Error();
    const user = JSON.parse(raw);
    const id = Number(user?.id);
    if (!Number.isFinite(id) || id <= 0) throw new Error();
    return id;
  } catch {
    throw new Error("No se encontró sabi_user.id en localStorage.");
  }
}

/**
 * CREAR / OBTENER HILO (WEB)
 * POST /hr/areas/messaging/licenses/:licenseId/chats
 */
export const crearChatHilo = (data) => {
  const licenseId = getLicenseIdOrThrow();
  const employeeId = data?.employeeId ?? data?.id_empleado;

  if (!employeeId) throw new Error("employeeId / id_empleado es requerido");

  return httpClient.post(
    `/hr/areas/messaging/licenses/${licenseId}/chats`,
    { employeeId }
  );
};

/**
 * LISTAR EMPLEADOS PARA CHAT (WEB)
 * GET /hr/areas/messaging/licenses/:licenseId/chat-employees
 */
export const listarChatEmpleados = (filters = {}) => {
  const licenseId = getLicenseIdOrThrow();

  const query = qs({
    q: filters.q,
    branchId: filters.branchId ?? filters.sucursal_id,
    areaId: filters.areaId ?? filters.area_id,
    status: filters.status ?? filters.estado_contrato,
    chatState: filters.chatState ?? filters.chat_estado,
    limit: filters.limit ?? 200,
    offset: filters.offset ?? 0,
  });

  return httpClient.get(
    `/hr/areas/messaging/licenses/${licenseId}/chat-employees${query}`
  );
};

/**
 * LISTAR CHATS
 */
export const listarChats = (filters = {}) => {
  const licenseId = getLicenseIdOrThrow();

  const query = qs({
    state: filters.state,
    limit: filters.limit ?? 50,
    offset: filters.offset ?? 0,
  });

  return httpClient.get(
    `/hr/areas/messaging/licenses/${licenseId}/chats${query}`
  );
};

/**
 * MENSAJES DEL CHAT
 */
export const listarMensajesChat = (threadId) => {
  const licenseId = getLicenseIdOrThrow();
  if (!threadId) throw new Error("threadId / hiloId es requerido");

  return httpClient.get(
    `/hr/areas/messaging/licenses/${licenseId}/chats/${threadId}/messages`
  );
};

export const enviarMensajeChat = (threadId, data) => {
  const licenseId = getLicenseIdOrThrow();
  const sentByUserId = data?.sentByUserId ?? getCurrentUserIdOrThrow();
  const content = data?.content ?? data?.contenido;

  if (!threadId) throw new Error("threadId / hiloId es requerido");
  if (!content) throw new Error("data.content / data.contenido es requerido");

  return httpClient.post(
    `/hr/areas/messaging/licenses/${licenseId}/chats/${threadId}/messages`,
    { sentByUserId, content }
  );
};

/**
 * MARCAR CHAT LEÍDO (WEB)
 */
export const marcarChatLeidoWeb = (threadId) => {
  const licenseId = getLicenseIdOrThrow();
  if (!threadId) throw new Error("threadId / hiloId es requerido");

  return httpClient.post(
    `/hr/areas/messaging/licenses/${licenseId}/chats/${threadId}/read`,
    { readerType: "RRHH" }
  );
};

export const actualizarEstadoChat = (threadId, state) => {
  const licenseId = getLicenseIdOrThrow();
  if (!threadId) throw new Error("threadId es requerido");
  if (!state) throw new Error("state es requerido");

  return httpClient.patch(
    `/hr/areas/messaging/licenses/${licenseId}/chats/${threadId}`,
    { state }
  );
};